import { ContentCard } from '../../components/ContentCard/ContentCard';
import { useFormatting, useTranslation } from '../../i18n/i18n';
import { ApiBonus } from '../../types';
import { Table } from '../Table/Table';

type BonusOrdersTableProps = {
	orders: ApiBonus[];
};
export const BonusOrdersTable = ({ orders }: BonusOrdersTableProps): JSX.Element => {
	const t = useTranslation().bonusPage;

	const { asPrice, dateTimeFormat } = useFormatting();

	if (orders.length === 0) return <></>;

	return (
		<>
			<Table className="not-mobile" striped interactive>
				<thead>
					<tr>
						<th>{t.date}</th>
						<th>{t.order}</th>
						<th>{t.amount}</th>
						<th>{t.bonus}</th>
						<th>{t.bonusLeft}</th>
						<th>{t.expirationDate}</th>
					</tr>
				</thead>
				<tbody>
					{orders.map((o) => (
						<tr key={o.orderId || o.dateCreated}>
							<td>{dateTimeFormat(new Date(o.dateCreated), true)}</td>
							<td>{o.comment ? o.comment : o.orderId}</td>
							<td>{o.subTotal > 0 ? asPrice(o.subTotal) : ''}</td>
							<td>{asPrice(o.amount)}</td>
							<td>{asPrice(o.amountLeft)}</td>
							<td>{dateTimeFormat(new Date(o.dateExpires), true)}</td>
						</tr>
					))}
				</tbody>
			</Table>
			<div className="only-mobile">
				{orders.map((order) => (
					<ContentCard className="order-card" key={order.orderId || order.dateCreated}>
						<div className="flex space-between">
							<p>
								<span className="bold">{t.order}:</span> {order.orderId}{' '}
							</p>
							<p className="date">{dateTimeFormat(new Date(order.dateCreated))}</p>
						</div>
						<hr />
						<div className="flex space-between">
							<p className="label">{t.amount}</p>
							{<p className="label">{t.bonus}</p>}
							{<p className="label">{t.bonusLeft}</p>}
						</div>
						<div className="flex space-between  order-group">
							<p className="flex-basis-100">{order.subTotal > 0 ? asPrice(order.subTotal) : ''}</p>
							{<p className="flex-basis-100">{asPrice(order.amount)}</p>}
							<p className="flex-basis-100">{asPrice(order.amountLeft)}</p>
						</div>
						<p className="label">{t.expirationDate}</p>
						<p>{dateTimeFormat(new Date(order.dateExpires), true)}</p>
					</ContentCard>
				))}
			</div>
		</>
	);
};
